export default {
    path: "/usuarios",
    name: "Users",
    component: () => import("@/presentation/views/Users/Users.vue"),
    redirect: { name: "UsersList" },
    meta: { requiresAuth: true },
    list: {
        path: "lista",
        name: "UsersList",
        component: () =>
            import("@/presentation/views/Users/UsersList/UsersList.vue"),
    },
    detail: {
        path: "detalhes/:id",
        name: "UserDetail",
        component: () =>
            import("@/presentation/views/Users/UserDetail/UserDetail.vue"),
        redirect: {
            name: "UserDetailInfo",
        },
        info: {
            path: "informacoes",
            name: "UserDetailInfo",
            component: () =>
                import(
                    "@/presentation/views/Users/UserDetail/UserDetailInfo/UserDetailInfo.vue"
                ),
        },
        sessions: {
            path: "sessoes",
            name: "UserDetailSessions",
            component: () =>
                import(
                    "@/presentation/views/Users/UserDetail/UserDetailSessions/UserDetailSessions.vue"
                ),
        },
    },
} as const